export default SELECTORS = {
  productTypeVariant: '.product__selectors .radio__button input',
  PDPRecipientFormCheckbox: 'recipient-form input[data-recipient-checkbox]',
  PDPGiftCardTypeVariantOptions: '[data-product-info] .product__selectors .gift-card-type-button',
  PDPAmountVariant: '.product__selectors [is-amount-variant]',
}